import { render } from "./UserWalls.vue?vue&type=template&id=dacc0b7e&scoped=true"
import script from "./UserWalls.vue?vue&type=script&lang=js"
export * from "./UserWalls.vue?vue&type=script&lang=js"

import "./UserWalls.vue?vue&type=style&index=0&id=dacc0b7e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacc0b7e"]])

export default __exports__